import React, {FC} from "react"
import {withRouter} from "react-router-dom"
import PropTypes from "prop-types"

import Flex from "@irati/ui/src/Flex"
import adminTracking from "@irati-tracking/admin"
import {
  ADMIN_HOME,
  SETTINGS_CUSTOMISE,
  SETTINGS_CUSTOMISE_BRAND,
  SETTINGS_CUSTOMISE_PERKS_VISIBILITY,
  SETTINGS_CUSTOMISE_BENEFITS,
  SETTINGS_CUSTOMISE_VALUES,
  SETTINGS_CUSTOMISE_CELEBRATIONS,
  PEOPLE,
  TEAMS,
  VIEW_BUSINESS_UNITS,
  ANALYTICS_BASE,
  SETTINGS_LOGIN_INTEGRATION,
  SETTINGS_LOGIN_INTEGRATION_DSYNC,
  HELP,
  SETTINGS_PERMISSIONS_RECOGNITION,
  SETTINGS_LOGIN_SSU,
  BILLING,
  AUTOMATION_BASE,
  SETTINGS_CUSTOM_REWARDS,
  SETTINGS_CUSTOM_REWARDS_CREATE,
  SETTINGS_CUSTOMISE_WELLBEING_CONTENT_VISIBILITY
} from "@irati-web/admin/src/routes/routeConfig"

import BreadCrumbs from "../BreadCrumbs"

interface Props {}

const AdminHeader: FC<Props> = (props, context) => {
  const isExactRoute = (route: string) => {
    const {ADMIN} = context.apps
    const pathname = window.location.pathname
    return pathname === `${ADMIN}${route}`
  }

  const isSubRoute = (route: string) => {
    const {ADMIN} = context.apps
    const pathname = window.location.pathname
    return pathname.includes(`${ADMIN}${route}`)
  }

  const getBreadCrumbsData = () => {
    if (isExactRoute(ADMIN_HOME)) {
      return [{title: "platform.adminNavigation.primary.home"}]
    }
    const breadcrumbs = [
      {
        title: "platform.adminNavigation.primary.home",
        to: ADMIN_HOME
      }
    ]
    if (isSubRoute(SETTINGS_CUSTOMISE)) {
      breadcrumbs.push({
        title: "platform.adminNavigation.primary.customisation",
        to: SETTINGS_CUSTOMISE
      })
      if (isExactRoute(SETTINGS_CUSTOMISE_BRAND)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.logos"}]
      }
      if (isExactRoute(SETTINGS_CUSTOMISE_PERKS_VISIBILITY)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.perkVisibility"}]
      }
      if (isExactRoute(SETTINGS_CUSTOMISE_WELLBEING_CONTENT_VISIBILITY)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.wellbeingContentVisibility"}]
      }
      if (isExactRoute(SETTINGS_CUSTOMISE_BENEFITS)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.customBenefits"}]
      }
      if (isExactRoute(SETTINGS_CUSTOMISE_VALUES)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.companyValues"}]
      }
      if (isExactRoute(SETTINGS_CUSTOMISE_CELEBRATIONS)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.companyCelebrations"}]
      }
      if (isExactRoute(SETTINGS_CUSTOM_REWARDS)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.customRewards"}]
      }
      if (isExactRoute(SETTINGS_CUSTOM_REWARDS_CREATE)) {
        return [...breadcrumbs, {title: "platform.adminNavigation.secondary.customRewardsCreate"}]
      }
    }
    // do if subroute is analytics here?!
    if (isExactRoute(SETTINGS_PERMISSIONS_RECOGNITION)) {
      return [
        ...breadcrumbs,
        {title: "platform.adminNavigation.primary.settings", to: SETTINGS_PERMISSIONS_RECOGNITION},
        {title: "platform.adminNavigation.secondary.roles"}
      ]
    }
    if (isExactRoute(SETTINGS_LOGIN_SSU)) {
      return [
        ...breadcrumbs,
        {title: "platform.adminNavigation.primary.settings", to: SETTINGS_PERMISSIONS_RECOGNITION},
        {title: "platform.adminNavigation.secondary.ssu"}
      ]
    }
    if (isSubRoute(PEOPLE)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.people"}]
    }
    if (isSubRoute(TEAMS)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.teams"}]
    }
    if (isExactRoute(VIEW_BUSINESS_UNITS)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.countries"}]
    }
    if (isSubRoute(ANALYTICS_BASE)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.analytics"}]
    }
    if (isSubRoute(AUTOMATION_BASE)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.automation"}]
    }
    if (isExactRoute(SETTINGS_LOGIN_INTEGRATION)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.integration"}]
    }
    if (isExactRoute(SETTINGS_LOGIN_INTEGRATION_DSYNC)) {
      return [
        ...breadcrumbs,
        {title: "platform.adminNavigation.primary.integration", to: SETTINGS_LOGIN_INTEGRATION},
        {title: "platform.adminNavigation.primary.dsyncIntegration"}
      ]
    }
    if (isExactRoute(HELP)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.help"}]
    }
    if (isExactRoute(BILLING)) {
      return [...breadcrumbs, {title: "platform.adminNavigation.primary.billing"}]
    }
    return breadcrumbs
  }

  const breadCrumbsDataWithTracking = getBreadCrumbsData().map((item) => ({
    ...item,
    onClick: adminTracking.adminHeaderClickBreadcrumbs
  }))
  return (
    <Flex alignItems="flex-end">
      <BreadCrumbs data={breadCrumbsDataWithTracking} />
    </Flex>
  )
}

AdminHeader.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default withRouter(AdminHeader)
